export const FETCH_METRICS_REQUEST = "FETCH_METRICS_REQUEST";
export const FETCH_METRICS_SUCCESS = "FETCH_METRICS_SUCCESS";
export const FETCH_METRICS_FAILURE = "FETCH_METRICS_FAILURE";

export const FETCH_TRANSACTION_METRICS_REQUEST =
  "FETCH_TRANSACTION_METRICS_REQUEST";
export const FETCH_TRANSACTION_METRICS_SUCCESS =
  "FETCH_TRANSACTION_METRICS_SUCCESS";
export const FETCH_TRANSACTION_METRICS_FAILURE =
  "FETCH_TRANSACTION_METRICS_FAILURE";
